// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ConversationParticipantsDisplay = require("./ConversationParticipantsDisplay.bs.js");
let ConversationsListItemParticipants_conversation_graphql = require("../../../__generated__/ConversationsListItemParticipants_conversation_graphql.bs.js");

let convertFragment = ConversationsListItemParticipants_conversation_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsListItemParticipants_conversation_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsListItemParticipants_conversation_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationsListItemParticipants_conversation_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationsListItemParticipants_conversation_graphql.node, convertFragment, fRef);
}

let ConversationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationsListItemParticipants(props) {
  let conversation = RescriptRelay_Fragment.useFragment(ConversationsListItemParticipants_conversation_graphql.node, convertFragment, props.conversation);
  let match = conversation.conversationListParticipants;
  if (match !== undefined) {
    return JsxRuntime.jsx(ConversationParticipantsDisplay.make, {
      participantsConnection: match.fragmentRefs,
      showNames: props.showNames
    });
  } else {
    return null;
  }
}

let make = ConversationsListItemParticipants;

exports.ConversationFragment = ConversationFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
